import { Typography, Tag } from 'antd'

interface INFTTrait{
  name: string
  variant: string
}
const { Text } = Typography
export const NFTTrait = ({ name, variant }: INFTTrait): JSX.Element => {
  return (
    <Tag className='nft-trait'>
      <Text style={{ fontSize: '20px', fontWeight: 700, lineHeight: '30px' }}>{name}: </Text><Text style={{ fontSize: '20px', fontWeight: 450, lineHeight: '30px', color: '#CC1024' }}>{variant}</Text>
    </Tag>
  )
}
